module.exports = __webpack_public_path__ + "img/stepThird.6e2c4f18.png";